
const popupCloseButtonTypes = {

  SQUARE: 1,
  NORMAL: 2

};

export default popupCloseButtonTypes;



// WEBPACK FOOTER //
// ./src/consts/popupCloseButtonTypes.js